import useUser from "../hooks/useUser";

//Returns nothing if user is not SA
const SuperAdminGuard = ({ children }) => {
    const user = useUser();
    return <>{user.isSuperAdmin ? children : null}</>;
}
export default SuperAdminGuard;